import React, { Component } from 'react';
import upload_hcm from './../../assets/upload_hcm.svg';
import upload_file from './../../assets/upload_file.svg';
import upload_manual from './../../assets/upload_manual.svg';

class ChooseUploadCategory extends Component {
  render() { 
    // console.log(this.props);
    return ( 
      <div className="upload_data_container">
        <div className="title-text" style={{fontWeight:'bolder'}}>
          Upload Data
        </div>
        <hr style={{marginBottom:'30px'}}/>
        <div className="mt10 item-subheader">
          Please choose how would you like to upload your employee data.
        </div>
        <div className="row mt40">
          
          
        
          <div className="col-md-4 col-lg-4 text-center cursor-pointer" 
            onClick={() => this.props.history.push('upload-data/csv')}>
            <img src={upload_file}/>
            <div className="mt30 choose-category-text">
              Import from a file
            </div>
            <div className="optional-text" style={{color:'#5455F'}}>
              ( e.g. Employment or hiring data)
            </div>
          </div>
          
          <div className="col-md-4 col-lg-4 text-center cursor-pointer"
            onClick={() => this.props.history.push('upload-data/manual')}>
            <img src={upload_manual}/>
            <div className="mt30 choose-category-text">
              Manual data entry
            </div>
            <div className="optional-text" style={{color:'#5455F'}}>
              (e.g. processes and policies data)
            </div>
          </div>
          

          <div className="col-md-4 col-lg-4 text-center">
            <img src={upload_hcm}/>
            <div className="mt30 choose-category-text">
              Connect HCM
            </div>
          </div>


        </div>
      </div>
    );
  }
}
 
export default ChooseUploadCategory;